import { render, staticRenderFns } from "./MgnlEditorial.vue?vue&type=template&id=36fc0a2b&"
import script from "./MgnlEditorial.vue?vue&type=script&lang=js&"
export * from "./MgnlEditorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports